export default {
  loading: false
};
